export default {
  loading: false
};
